<div id="modal-content">
  <div class="card card-secondary card-outline">
    <div class="card-header bg-light">
      <h4 class="card-title mb-0">{{ titulo }} Fase de Atividade</h4>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="cancelar()"><i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <form [formGroup]="formFase" #f="ngForm">
      <div class="card-body p-0">
        <div class="table-container">
          <div class="row p-3">
            <div class="form-group col-md-12">
              <label for="inputNome" class="mb-1">Nome</label>
              <input [attr.disabled]="visualizar ? true : null" type="text" id="inputNome"
                class="form-control form-control-sm" formControlName="nome" maxlength="200"
                [ngClass]="{ 'is-invalid': f.submitted && formFase.controls['nome'].invalid }" />
              <div *ngIf="f.submitted && formFase.controls['nome'].invalid" class="invalid-feedback">
                <div *ngIf="formFase.controls['nome'].errors.required">Campo obrigatório</div>
              </div>
            </div>
            <div class="form-group col-md-12">
              <label for="quantidadeDias" class="mb-1">Quantidade de Dias</label>
              <input [attr.disabled]="visualizar ? true : null" type="text" id="inputQuantidadeDias"
                class="form-control form-control-sm" formControlName="quantidadeDias" maxlength="200"
                [ngClass]="{ 'is-invalid': f.submitted && formFase.controls['nome'].invalid }" />
              <div *ngIf="f.submitted && formFase.controls['quantidadeDias'].invalid" class="invalid-feedback">
                <div *ngIf="formFase.controls['quantidadeDias'].errors.required">Campo obrigatório</div>
              </div>
            </div>
            <div class="form-group col-md-12">
              <label for="inputDescricao" class="mb-1">Descrição</label>
              <textarea [attr.disabled]="visualizar ? true : null" rows="3" id="inputDescricao"
                class="form-control form-control-sm" formControlName="descricao" maxlength="500"
                [ngClass]="{ 'is-invalid': f.submitted && formFase.controls['descricao'].invalid }">
              </textarea>
              <div *ngIf="f.submitted && formFase.controls['descricao'].invalid" class="invalid-feedback">
                <div *ngIf="formFase.controls['descricao'].errors.required">Campo obrigatório</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="btn-group" [hidden]="visualizar">
          <button class="btn btn-primary btn-sm mr" (click)="salvar(false)">
            <i class="far fa-save"></i> Salvar
          </button>
          <button type="button" class="btn btn-primary btn-sm mr dropdown-toggle dropdown-icon" data-toggle="dropdown"
            aria-expanded="false"></button>
          <div class="dropdown-menu" role="menu">
            <a class="dropdown-item" (click)="salvar(false)">Salvar</a>
            <a class="dropdown-item" (click)="salvar(true)">Salvar e fechar</a>
          </div>
        </div>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
          <i class="fas fa-times"></i> Cancelar
        </button>
      </div>
    </form>
  </div>
</div>